<template>
    <div class="user-profile">
        <grid-single-column>
            <div class="user-profile__content">
                <profile-content></profile-content>
            </div>
        </grid-single-column>
    </div>
</template>
<script>
import profileContent from "@/components/profile/profile-content.vue"
import {
    CLEAR_CURRENT_PROFILE,
    CLEAR_PROFILE_POST_LIST
} from "@/store/mutations.type"
export default {
    name: 'Profile',
    components: {
        'profile-content': profileContent
    },

    destroyed() {
        this.$store.commit(CLEAR_CURRENT_PROFILE)
        this.$store.commit(CLEAR_PROFILE_POST_LIST)
    }
}
</script>